import React from 'react'
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import moment from 'moment';
import "./styles.css";
export default function CampaingRow({
  index,
  data,
  companyLevelComplaiceFlag,
  tab,
  role,
  viewCampaign,
  editCampaign,
  campLabel,
  viewReport,
  cloneCamp,
  toAudience,
  archive
}) {
  let FirstRundate = moment(data.campaignSchedule.firstRunDate).utc().format('MM/DD/YYYY');
  return (
    <div key={index} className="cmpgn-list-card">
      <div className="row">
        <div className="col-lg-4">
          <div className="heading_status ">
            <h3>{data.name}</h3>
          </div>
          <p>{data.description}</p>
          <a
            href={data.publishUrl}
            target="_blank"
            id="published_url"
          >
            {data.publishUrl}
          </a>
        </div>
        <div className="col-lg-8">
          
          
          <ul className="Pb_status_list gap-2 d-flex justify-content-center">
  

            <li className='w-100 d-flex gap-2 justify-content-center'>
              <div className="campaign_actions d-flex w-100" style={{maxWidth: "200px"}}>
                {tab === "compliancePending" &&
                  data.complianceStatus === "Pending" &&
                  role === "compliance" && (
                    <OverlayTrigger
                      delay={{ hide: 50, show: 50 }}
                      placement="top"
                      // key="top"
                      overlay={(props) => (
                        <Tooltip id="tooltip-top" {...props}>
                          View and Approve
                        </Tooltip>
                      )}
                    >
                      <li style={{width: "fit-content"}}>
                        <a
                          to=""
                          className="lg_btn primary"
                          onClick={() => editCampaign(data.id)}
                          style={{
                            minWidth: "200px",
                            padding: "9px 9px",
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          View and Approve
                        </a>
                      </li>
                    </OverlayTrigger>
                  )}
                {!(tab === "compliancePending") && (
                  data.isDraft !== true && (
                    data.type == "email" && (
                      <OverlayTrigger
                        delay={{ hide: 50, show: 50 }}
                        placement="top"
                        // key="top"
                        overlay={(props) => (
                          <Tooltip id="tooltip-top" {...props}>
                            View Report
                          </Tooltip>
                        )}
                      >
                        <li>
                          <div className="select-wrap">
                            <i
                              className="far fa-file-alt"
                              onClick={() => viewReport(data)}
                            ></i>
                          </div>
                        </li>
                      </OverlayTrigger>
                    )
                  )
                )}
                {
                  !(tab === "compliancePending") && ((data.type == "email" && data.isDraft == true) || data.type == "publishedContent") && (
                    <OverlayTrigger
                      delay={{ hide: 50, show: 50 }}
                      placement="top"
                      // key="top"
                      overlay={(props) => (
                        <Tooltip id="tooltip-top" {...props}>
                          Edit
                        </Tooltip>
                      )}
                    >
                      <li>
                        <div className="select-wrap">
                          <i
                            className="far fa-edit"
                            onClick={() => editCampaign(data.id)}
                          ></i>
                        </div>
                      </li>
                    </OverlayTrigger>
                  )
                }
                {!(tab === "compliancePending") &&
                  (data.type == "email" && data.isABTest !== true) && (
                    <OverlayTrigger
                      delay={{ hide: 50, show: 50 }}
                      placement="top"
                      // key="top"
                      overlay={(props) => (
                        <Tooltip id="tooltip-top" {...props}>
                          Clone
                        </Tooltip>
                      )}
                    >
                      <li>
                        <div className="select-wrap">
                          <i
                            className="far fa-clone"
                            onClick={() => cloneCamp(data)}
                          ></i>
                        </div>
                      </li>
                    </OverlayTrigger>
                  )}

                {(
                    <OverlayTrigger
                      delay={{ hide: 50, show: 50 }}
                      placement="top"
                      // key="top"
                      overlay={(props) => (
                        <Tooltip id="tooltip-top" {...props}>
                           {data.status=='Deleted'? "Unarchive": "Archive"}
                        </Tooltip>
                      )}
                    >
                      <li>
                        <div className="select-wrap">
                          <i
                          className="far fa-file-archive"
                            onClick={() => archive(data)}
                          ></i>
                        </div>
                      </li>
                    </OverlayTrigger>
                  )}

                {((data.status === "Active" || data.status === "Completed" || data.status === "Paused") && (!data.isDraft)) && < OverlayTrigger
                  delay={{ hide: 50, show: 50 }}
                  placement="top"
                  // key="top"
                  overlay={(props) => (
                    <Tooltip id="tooltip-top" {...props}>
                      View Campaign
                    </Tooltip>
                  )}
                >
                  <li>
                    <div className="select-wrap">
                      <i
                        className="far fa-eye"
                        onClick={() => viewCampaign(data.id)}
                      ></i>
                    </div>
                  </li>
                </OverlayTrigger>}
              </div>
            </li>
          </ul>


        </div>
      </div>
      {/* style={{ display: "grid", gridTemplateColumns: '41% 59%', paddingLeft: '15px' }} */}
      <div className='row'>

        <div className="cam-item" >
          <label style={campLabel}>Created:</label>
          <div className="cmpg-info-detail">{data.createdAt}</div>
        </div>

        <div className="cam-item" >
          <label style={campLabel}>Created by:</label>
          <div className="cmpg-info-detail">
            {data.user ? data.user : "You"}
          </div>
        </div>

        <div className="cam-item">
          <label style={campLabel}>Type:</label>
          <div className="cmpg-info-detail">
            {data.type === "publishedContent" && "Published Content"}
            {data.type === "email" && data.isABTest ? 'AB test' : data.type === "email" && "Email"}
          </div>
        </div>

        {data.audienceId && <div className="cam-item" >
          <label style={campLabel}>Audience:</label>
          <div className="cmpg-info-detail">
            <a
              target="_blank"
              id="published_url"
              style={{ cursor: 'pointer' }}
              onClick={() =>{
                sessionStorage.setItem("audience_list_id", data.audienceId.id);
                sessionStorage.setItem("audience_list_name", data.audienceId.name);
                toAudience(data.audienceId.id)}
              }
            >
              {data.audienceId.name}
            </a>
          </div>
        </div>}



        <div className="cam-item" >
          <label style={campLabel}>Status:</label>

          <div className={data.status == 'Completed' && !data.isDraft?  "gr-status " : "cmpg-info-detail or-status "}>
            <span className='circ'></span>
            <span>{data.isDraft ? 'Draft' : data.status}</span>
            
            </div>
        </div>

        {
          !data.isDraft && role !='publisher' &&<div className="cam-item">
            <label style={campLabel}>Scheduled for:</label>
            <div className="cmpg-info-detail" style={{ textTransform: 'uppercase' }}>{
              data.campaignSchedule.type === "now" || data.campaignSchedule.type === "once" ?
                `${FirstRundate} : ${data.campaignSchedule.runTime} UTC` :
                 
                 `${data.campaignSchedule.type}, ${data.campaignSchedule.typeValue}, ${FirstRundate} : ${data.campaignSchedule.runTime} UTC`

            }</div>
          </div>
        }
        {companyLevelComplaiceFlag ?
          <div className="row" >
            <label style={campLabel}>Compliance:</label>
            <div className="cmpg-info-detail">
              {data.complianceStatus == 'Editing' ? 'Draft' : data.complianceStatus}
            </div>
          </div>
          : null}

      </div>

      <div className='horz-line'>

      </div>
      <div className='row' >
              <div className="pb_status">
                <span>
                  <i className="fa fa-paper-plane mr-2"></i>{" "}
                  {data.campaignAnalytics.totalSend}
                </span>
                <span>Sent</span>
              </div>
     
              <div className="pb_status">
                <span>
                  <i className="fas fa-folder-open mr-2"></i>{" "}
                  {data.campaignAnalytics.totalOpen}
                </span>
                <span>Opens</span>
              </div>
       
              <div className="pb_status">
                <span>
                  <img
                    className="mr-2"
                    src={require("assets/img/click.svg")}
                  />{" "}
                  {data.campaignAnalytics.totalClick}
                </span>
                <span>Clicks</span>
              </div>
     
              <div className="pb_status">
                <span>
                  <i className="fas fa-bell mr-2"></i>{" "}
                  {data.campaignAnalytics.totalUnsubscribe}
                </span>
                <span>Unsubscribed</span>
              </div>
      </div>



    </div>
  )
}
